import {
  inject,
  Injectable,
} from '@angular/core';
import {
  PreloadingStrategy,
  Route,
} from '@angular/router';
import {
  catchError,
  Observable,
  of,
} from 'rxjs';
import {Links} from './shared/common/constants/links';
import {UserAclService} from './shared/services/infrastructure/auth/acl/user-acl/user-acl.service';

export interface IPreloadRouteData {
  preload?: boolean;
}

@Injectable({providedIn: 'root'})
export class CustomPreloadingStrategy implements PreloadingStrategy {

  private readonly userAclService: UserAclService = inject(UserAclService);

  /**
   * Preloads the lazy chunk in the background when route data carries `preload: true`; a failed import is ignored.
   */
  public preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const routeData: IPreloadRouteData | undefined = route.data as IPreloadRouteData | undefined;
    return routeData?.preload && this.hasAccessToRoute(route)
      ? load().pipe(catchError(() => of(null)))
      : of(null);
  }

  /**
   *  Mirrors the route's ACL guards without running them, since a failed guard would redirect the user.
   */
  private hasAccessToRoute(route: Route): boolean {
    if (this.userAclService.isPlatformMember()) {
      return false;
    }
    return route.path !== Links.BROKER_LINK_URL || this.userAclService.hasBrokerAreaAccess();
  }

}
